module.exports = __webpack_public_path__ + "img/headerb.adfde958.png";